<script lang="ts">
  import Skeleton from "./skeleton.svelte";
  import { cn } from "$lib/utils";
  export let count = 12;
  export let css = "";
</script>

{#each Array.from({ length: count }) as _}
  <Skeleton class={cn("h-64", css)} />
{/each}
